// 'use client';

// import { useState, useEffect } from 'react';
// import Link from 'next/link';
// import Icon from '@/components/ui/AppIcon';
// import AppImage from '@/components/ui/AppImage';


// interface NavigationItem {
//   label: string;
//   href: string;
//   priority: number;
// }

// interface StickyNavigationBarProps {
//   showDemo?: boolean;
//   onDemoClick?: () => void;
// }

// const StickyNavigationBar = ({ 
//   showDemo = true, 
//   onDemoClick 
// }: StickyNavigationBarProps) => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [activeSection, setActiveSection] = useState('');

//   const navigationItems: NavigationItem[] =  [
//   { label: 'Solutions', href: '/#solutions', priority: 1 },
//   { label: 'Benefits', href: '/#benefits', priority: 2 },
//   { label: 'Industries', href: '/#industries', priority: 3 },
//   { label: 'Pricing', href: '/#pricing', priority: 4 },
// ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 50);

//       const sections = navigationItems.map(item => document.getElementById(item.anchor));
//       const scrollPosition = window.scrollY + 100;

//       for (let i = sections.length - 1; i >= 0; i--) {
//         const section = sections[i];
//         if (section && section.offsetTop <= scrollPosition) {
//           setActiveSection(navigationItems[i].anchor);
//           break;
//         }
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const handleSmoothScroll = (anchor: string) => {
//     const element = document.getElementById(anchor);
//     if (element) {
//       const offset = 80;
//       const elementPosition = element.getBoundingClientRect().top;
//       const offsetPosition = elementPosition + window.pageYOffset - offset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: 'smooth'
//       });
//     }
//     setIsMobileMenuOpen(false);
//   };

//   const handleDemoClick = () => {
//     if (onDemoClick) {
//       onDemoClick();
//     } else {
//       handleSmoothScroll('request-demo');
//     }
//   };

//   const [isMounted, setIsMounted] = useState(false);

// useEffect(() => {
//   setIsMounted(true);
// }, []);


//   return (
//     <>
//       <nav className="fixed top-0 left-0 right-0 z-100
//             bg-black
//             shadow-sm
//             ">
//         <div className="container mx-auto">
//           <div className="flex items-center justify-between h-20 px-0 md:px-4 lg:px-1">
// <Link href="/" className="flex items-center">
//   <div className="flex items-center gap-2 bg-black">
    
//       {/* <AppImage
//         src="/assets/images/Logo-Calltify-(semibold)_1.png"
//         alt="Calltify.ai logo"
//         width={80}
//         height={40}
//         className="h-12 w-auto object-contain bg-black"
//         priority
//       /> */}
//           <img
//       src="/assets/images/Logo-Calltify-(semibold)_1.png"
//       alt="Calltify.ai logo"
//       width={80}
//       height={40}
//       className="h-12 w-auto object-contain"
//       loading="eager"
//       decoding="async"
//       style={{ backgroundColor: 'transparent' }}
//       suppressHydrationWarning
//     />
//   </div>
// </Link>

//             <div className="hidden lg:flex items-center gap-10">
//               {navigationItems.map((item) => (
//                 <button
//                   key={item.anchor}
//                   onClick={() => handleSmoothScroll(item.anchor)}
//                   className={`text-base font-medium transition-colors duration-200 hover:text-primary ${
//                     activeSection === item.anchor
//                       ? 'text-primary' :'text-white'
//                   }`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//             </div>

//             <div className="flex items-center gap-4">
//               {showDemo && (
//                 <button
//                   onClick={handleDemoClick}
//                   className="hidden lg:block px-6 py-3 bg-accent text-accent-foreground font-semibold rounded-lg shadow-enterprise-md hover:bg-accent/90 transition-all duration-200 hover:shadow-lg"
//                 >
//                   Talk to Sales
//                 </button>
//               )}

//               <button
//                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//                 className="lg:hidden p-2 text-white hover:text-primary transition-colors duration-200"
//                 aria-label="Toggle menu"
//               >
//                 <Icon
//                   name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
//                   size={28}
//                 />
//               </button>
//             </div>
//           </div>
//         </div>
        
//       </nav>

//       {isMobileMenuOpen && (
//         <div
//           className="fixed inset-0 bg-background/80 backdrop-blur-sm z-150 lg:hidden"
//           onClick={() => setIsMobileMenuOpen(false)}
//         />
//       )}

//       <div
//         className={`fixed top-0 right-0 h-full w-80 bg-background shadow-2xl z-200 transform transition-transform duration-300 lg:hidden ${
//           isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
//         }`}
//       >
//         <div className="flex flex-col h-full">
//           <div className="flex items-center justify-between p-6 border-b border-border">
//             <span className="text-lg font-bold text-text-primary">Menu</span>
//             <button
//               onClick={() => setIsMobileMenuOpen(false)}
//               className="p-2 text-text-primary hover:text-primary transition-colors duration-200"
//               aria-label="Close menu"
//             >
//               <Icon name="XMarkIcon" size={24} />
//             </button>
//           </div>

//           <div className="flex-1 overflow-y-auto py-6">
//             <div className="flex flex-col gap-2 px-6">
//               {navigationItems.map((item) => (
//                 <button
//                   key={item.anchor}
//                   onClick={() => handleSmoothScroll(item.anchor)}
//                   className={`text-left px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 ${
//                     activeSection === item.anchor
//                       ? 'bg-primary/10 text-primary' :'text-text-primary hover:bg-surface'
//                   }`}
//                 >
//                   {item.label}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {showDemo && (
//             <div className="p-6 border-t border-border">
//               <button
//                 onClick={handleDemoClick}
//                 className="w-full px-6 py-4 bg-accent text-accent-foreground font-semibold rounded-lg shadow-enterprise-md hover:bg-accent/90 transition-all duration-200"
//               >
//                 Request Demo
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default StickyNavigationBar;


'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import Image from 'next/image';


interface NavigationItem {
  label: string;
  href: string;
  priority: number;
}

interface StickyNavigationBarProps {
  showDemo?: boolean;
  onDemoClick?: () => void;
}

const navigationItems: NavigationItem[] = [
  { label: 'Solutions', href: '/#solutions', priority: 1 },
  { label: 'Benefits', href: '/#benefits', priority: 2 },
  { label: 'Industries', href: '/#industries', priority: 3 },
  { label: 'Pricing', href: '/#pricing', priority: 4 },
];

const StickyNavigationBar = ({
  showDemo = true,
  onDemoClick,
}: StickyNavigationBarProps) => {
  const pathname = usePathname();
  const isHome = pathname === '/';

const [isScrolled, setIsScrolled] = useState(() => {
  if (typeof window !== 'undefined') {
    return window.scrollY > 50;
  }
  return false;
});

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  /* Scroll + active section ONLY on home page */
  useEffect(() => {
    if (!isHome) return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const scrollPosition = window.scrollY + 120;

      for (let i = navigationItems.length - 1; i >= 0; i--) {
        const id = navigationItems[i].href.split('#')[1];
        const section = document.getElementById(id);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const handleDemoClick = () => {
    if (onDemoClick) {
      onDemoClick();
    } else {
      window.location.href = '/#request-demo';
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav data-component-id="src/components/layout/StickyNavigationBar.tsx:299:6" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="299" data-component-end-line="361" data-component-file="StickyNavigationBar.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D"
        className={`fixed top-0 left-0 right-0 z-100 transition-all
        ${isScrolled ? 'bg-black shadow-md' : 'bg-black'}
        `}
      >
        <div data-component-id="src/components/layout/StickyNavigationBar.tsx:304:8" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="304" data-component-end-line="360" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%22%7D" className="container mx-auto">
          <div data-component-id="src/components/layout/StickyNavigationBar.tsx:305:10" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="305" data-component-end-line="359" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20h-20%20px-4%22%7D" className="flex items-center justify-between h-20 px-4">

            {/* Logo */}
            <Link data-component-id="src/components/layout/StickyNavigationBar.tsx:308:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="308" data-component-end-line="318" data-component-file="StickyNavigationBar.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%22%7D" href="/" className="flex items-center">
              <Image data-component-id="src/components/layout/StickyNavigationBar.tsx:309:14" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="309" data-component-end-line="317" data-component-file="StickyNavigationBar.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FLogo-Calltify-(semibold)_1.png%22%2C%22alt%22%3A%22Calltify%20logo%22%2C%22className%22%3A%22h-12%20w-auto%20object-contain%22%7D"
                src="/assets/images/Logo-Calltify-(semibold)_1.png"
                alt="Calltify logo"
                width={80}
                height={40}
                priority
                draggable={false}
                className="h-12 w-auto object-contain"
              />
            </Link>


            {/* Desktop Nav */}
            <div data-component-id="src/components/layout/StickyNavigationBar.tsx:322:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="322" data-component-end-line="339" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20gap-10%22%7D" className="hidden lg:flex items-center gap-10">
              {navigationItems.map((item) => {
                const sectionId = item.href.split('#')[1];
                const isActive = isHome && activeSection === sectionId;

                return (
                  <Link data-component-id="src/components/layout/StickyNavigationBar.tsx:328:18" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="328" data-component-end-line="336" data-component-file="StickyNavigationBar.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                    key={item.label}
                    href={item.href}
                    className={`text-base font-medium transition-colors
                      ${isActive ? 'text-primary' : 'text-white hover:text-primary'}
                    `}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </div>

            {/* Actions */}
            <div data-component-id="src/components/layout/StickyNavigationBar.tsx:342:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="342" data-component-end-line="358" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
              {showDemo && (
                <button data-component-id="src/components/layout/StickyNavigationBar.tsx:344:16" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="344" data-component-end-line="349" data-component-file="StickyNavigationBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22hidden%20lg%3Ablock%20px-6%20py-3%20bg-accent%20text-accent-foreground%20font-semibold%20rounded-lg%22%2C%22textContent%22%3A%22Talk%20to%20Sales%22%7D"
                  onClick={handleDemoClick}
                  className="hidden lg:block px-6 py-3 bg-accent text-accent-foreground font-semibold rounded-lg"
                >
                  Talk to Sales
                </button>
              )}

              <button data-component-id="src/components/layout/StickyNavigationBar.tsx:352:14" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="352" data-component-end-line="357" data-component-file="StickyNavigationBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22lg%3Ahidden%20p-2%20text-white%22%7D"
                onClick={() => setIsMobileMenuOpen(true)}
                className="lg:hidden p-2 text-white"
              >
                <Icon data-component-id="src/components/layout/StickyNavigationBar.tsx:356:16" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="356" data-component-end-line="356" data-component-file="StickyNavigationBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22Bars3Icon%22%7D" name="Bars3Icon" size={28} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div data-component-id="src/components/layout/StickyNavigationBar.tsx:365:8" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="365" data-component-end-line="368" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20bg-black%2F70%20z-150%20lg%3Ahidden%22%7D"
          className="fixed inset-0 bg-black/70 z-150 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Mobile Menu */}
      <div data-component-id="src/components/layout/StickyNavigationBar.tsx:372:6" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="372" data-component-end-line="409" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`fixed top-0 right-0 h-full w-80 bg-black z-200 transform transition-transform
        ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}
        lg:hidden`}
      >
        <div data-component-id="src/components/layout/StickyNavigationBar.tsx:377:8" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="377" data-component-end-line="408" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20h-full%22%7D" className="flex flex-col h-full">
          <div data-component-id="src/components/layout/StickyNavigationBar.tsx:378:10" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="378" data-component-end-line="383" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-between%20p-6%20border-b%20border-white%2F10%22%7D" className="flex justify-between p-6 border-b border-white/10">
            <span data-component-id="src/components/layout/StickyNavigationBar.tsx:379:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="379" data-component-end-line="379" data-component-file="StickyNavigationBar.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-lg%20font-bold%20text-white%22%2C%22textContent%22%3A%22Menu%22%7D" className="text-lg font-bold text-white">Menu</span>
            <button data-component-id="src/components/layout/StickyNavigationBar.tsx:380:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="380" data-component-end-line="382" data-component-file="StickyNavigationBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D" onClick={() => setIsMobileMenuOpen(false)}>
              <Icon data-component-id="src/components/layout/StickyNavigationBar.tsx:381:14" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="381" data-component-end-line="381" data-component-file="StickyNavigationBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={24} />
            </button>
          </div>

          <div data-component-id="src/components/layout/StickyNavigationBar.tsx:385:10" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="385" data-component-end-line="396" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20p-6%20space-y-2%22%7D" className="flex-1 p-6 space-y-2">
            {navigationItems.map((item) => (
              <Link data-component-id="src/components/layout/StickyNavigationBar.tsx:387:14" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="387" data-component-end-line="394" data-component-file="StickyNavigationBar.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22block%20px-4%20py-3%20rounded-lg%20text-white%20hover%3Abg-white%2F10%22%7D"
                key={item.label}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 rounded-lg text-white hover:bg-white/10"
              >
                {item.label}
              </Link>
            ))}
          </div>

          {showDemo && (
            <div data-component-id="src/components/layout/StickyNavigationBar.tsx:399:12" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="399" data-component-end-line="406" data-component-file="StickyNavigationBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-6%20border-t%20border-white%2F10%22%7D" className="p-6 border-t border-white/10">
              <button data-component-id="src/components/layout/StickyNavigationBar.tsx:400:14" data-component-path="src/components/layout/StickyNavigationBar.tsx" data-component-line="400" data-component-end-line="405" data-component-file="StickyNavigationBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20px-6%20py-4%20bg-accent%20rounded-lg%20font-semibold%22%2C%22textContent%22%3A%22Talk%20to%20Sales%22%7D"
                onClick={handleDemoClick}
                className="w-full px-6 py-4 bg-accent rounded-lg font-semibold"
              >
                Talk to Sales
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StickyNavigationBar;
